module.exports = __webpack_public_path__ + "static/Wkład_stalowy_do_wymiennika_2-14f5c6432fbcc6360c9c20dfdae87bcb.png";